<template>
  <form id="frm_action">
  <div class="p-formgrid">
        <div class="p-card-field div-big">

          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Type Of Banner <span class="color">*</span></label>
            <div class="div-active">

            <div class="p-col checkbox div-active-item">
              <Checkbox  v-model="banner.large" :binary="true"/>
              <label class="p-col-fixed txt-right text-active">Large </label>
            </div>
            <div class="p-col checkbox div-active-item">
              <Checkbox  v-model="banner.medium" :binary="true"/>
              <label class="p-col-fixed txt-right text-active">Medium </label>
            </div>
            <div class="p-col checkbox div-active-item">
              <Checkbox  v-model="banner.small" :binary="true"/>
              <label class="p-col-fixed txt-right text-active">Small </label>
            </div>
            <div class="p-col checkbox div-active-item">
              <Checkbox  v-model="banner.intro" :binary="true"/>
              <label class="p-col-fixed txt-right text-active">Intro </label>
            </div>
            
            </div>
            <div class="div-p">
              <input class="input_tmp_validator" id="size-banner">
            <p class="p-col-fixed  text-distance color-text">-Large: 358x201px </p>
            <p class="p-col-fixed  text-distance color-text">-Medium: 358x119px </p>
            <p class="p-col-fixed  text-distance color-text">-Small: 358x60px </p>
            </div>
          </div>
          <div class="p-field p-grid div-block">
            <label class="txt-right label-thumbnail bold">Thumbnail <span class="color">*</span></label>
            <div class="p-col">

              <div class="p-col-width disabled width-thum" id="div-thumbnail">
                <label class="file-select">
                  <div class="select-button">
                    <span >Browse...</span>
                  </div>
                  <input accept="image/*" multiple name="images[]" type="file" @change="onFileSelect"/>
                </label>
              </div>
              <div class="div-label-bot">
                <input class="input_tmp_validator" id="images_va">
                <label class=" txt-right label-bot-item color-text">-Accepted: PNG, JPG, JPEG, GIF </label>
                <label class=" txt-right label-bot-item color-text">-Maximum upload file size: 500MB </label>
              </div>
              <div class="box-images p-grid"  v-if="images && images.length">
                <div class="item-img p-col-5" v-for="(item, index) in images" :key="index" >
                  <!-- <div class="button-clear" @click="onFileClear(index)"><img :src="require('../../../assets/ic_clear.svg')"/></div> -->
                  <img  :src="item.objectURL"/>
                </div>
              </div>
            </div>
          </div>
          <div   class="field col-12 md:col-4 div-calenda">
            <div class="div-canlenda-item">
            <label class=" txt-right label-bot-item bold">From</label>
              <Calendar v-on:input="change_from" class=" margin input_width border_color" dateFormat="dd-mm-yy"  placeholder=""  id="date_from" v-model="banner.from" :showIcon="true" />
            </div>
              <div class="div-canlenda-item">
            <label class=" txt-right label-bot-item bold">to</label>
              <Calendar v-on:input="change_to" class=" margin input_width border_color" dateFormat="dd-mm-yy" placeholder=""  id="date_to" v-model="banner.to" :showIcon="true" />
            </div>
            </div>

          <div class="p-card-field">
            <label class="p-col-fixed bold">Link</label>
            <div class="p-field p-grid" style="margin-bottom: 0px;">
              <Textarea class=" border_color link-width" :autoResize="true"  rows="1" maxlength="255" v-model="banner.link"  id="link" type="text"  placeholder="http:// " />
            </div>
          </div>
          <div class="p-card-field">
            <label class="p-col-fixed bold">Order</label>
            <div class="p-field p-grid">
              <InputNumber class=" border_color link-width" v-model="banner.ordinal" id="ordinal" :min="1"/>
            </div>
          </div>
          <div class="p-col checkbox div-active-item one-active">
            <Checkbox  v-model="banner.active" :binary="true"/>
            <label class="p-col-fixed txt-right text-active">Show </label>
          </div>
          
        </div>
    <Toolbar class="fixed-bottom-toolbar">
      <template slot="right">
        <Button
          label="Cancel"
          @click="backToList()"
          class="p-button-warning cancel"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Save'"
          @click="saveData()"
          class="p-button-success save"
        />
        <Button
          v-else
          :label="'Save'"
          @click="saveData()"
          class="p-button-success save"
        />
      </template>
    </Toolbar>
  </div>
  </form>
</template>

<script>
// import CkditorCore from '../CkditorCore';
import moment from 'moment';
export default {
  // components: {
  //   CkditorCore
  // },
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      name: '',
      name_en: '',
      banner: {
        large:false,
        medium:false,
        small:false,
        intro: false,
        active:true,
        link:'',
        from:'',
        to:'',
        ordinal : 1,
      },
      checkedProminent : false,
      checkedPromotion : true,
      checkedMember : false,
     
      validationErrors: {},
      formMode: this.mode,
      images: [],
      imagesDeletes: [],
      maxFileSize: 1000000, // 1MB
      maxFiles: 10,
      saving:false,
      content : '',
      content_en : '',
      imgDelete : [],
      time_zone_local : moment.tz.guess(),
      selType:{ value: 'OTHER', name: 'Khác'},
      list_rank : [],//.unshift({ value: 'OTHER', name: 'Khác'})
    }
  },
  mounted() {
    this.list_rank = [{ value: 'OTHER', name: 'Khác'}].concat(this.$constants.LIST_TYPE_RANK);
    console.log("sassasasa")
    console.log("this.model",this.model)
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      console.log("this.model11",this.model)
      this.banner.link = this.model.link;
      this.banner.from = this.model.date_from ? moment(this.model.date_from).format("MM-DD-yyyy"):null;
      this.banner.to = this.model.date_to ? moment(this.model.date_to).format("MM-DD-yyyy"):null;
      // this.banner.from = this.model.date_from;
      // this.banner.to = this.model.date_to;
      this.banner.active = this.model.active;
      this.banner.ordinal = this.model.ordinal;
      var list_type = this.model.banner_type ? this.model.banner_type:[]

      for (var i = 0 ; i < list_type.length ; i++){
        if (list_type[i].type == 'Large'){
          this.banner.large = true;
        }
        else if (list_type[i].type == "Medium"){
          this.banner.medium = true
        }
        else if (list_type[i].type == "Small"){
          this.banner.small = true
        }
        else if(list_type[i].type == "Intro"){
          this.banner.intro = true
        }
      }


      if(this.model.lang !== undefined && this.model.lang !== null && this.model.lang.length > 0){
        this.name_en = this.model.lang[0].name;
        this.content_en = this.model.lang[0].content;
      }
      
      if (!this.$commonFuction.isEmpty(this.model.img_banner)) {
        let url = this.model.img_banner
        let split = url.split('/')
        let fileName = split[split.length - 1]
        let obj = {'name': fileName, 'file': '', 'objectURL': url,type:'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
        this.images.push(obj)
      }
    }
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    isDate1BeforeDate2(date1, date2) {
      return moment(date1).isBefore(date2);
    },
    // change_from(){
    //   this.banner.from = this.banner.from ? moment(this.banner.from, 'DD/MM/yyyy'):null;
    //   this.banner.from = this.banner.from ? this.banner.from.format('MM/DD/yyyy'):null;
    //
    //
    // },
    // change_to(){
    //   this.banner.to = this.banner.to ? moment(this.banner.to, 'DD/MM/yyyy'):null;
    //   this.banner.to = this.banner.to ? this.banner.to.format('MM/DD/yyyy'):null;
    // },
    handleDataCkditor: function(e,key) {
      var dataContent = (e.length) ? e[0]:'';
      if (key == 'content'){
        this.content = dataContent;
      }else if (key == 'content_en'){
        this.content_en = dataContent;
      }
    },
    CallPhoneSel(){
      if(this.selUser !== undefined && this.selUser !== null){
        this.phone = this.selUser.phone
      }
    },
    async validateData() {

      let link = document.getElementById("link");
      if (!this.$commonFuction.isEmpty(this.banner.link)){
        console.log("linknknknkn",this.banner.link)

        if (this.banner.link.includes("http") == false){
          link.setCustomValidity("Invalid link");
        }
        else {
          link.setCustomValidity("");
        }
      }
      else {
        link.setCustomValidity("");
      }


      let size_banner = document.getElementById("size-banner");
      if (this.banner.large == false && this.banner.medium == false && this.banner.small == false && this.banner.intro == false){
        size_banner.setCustomValidity("Please enter the size");
      }else {
        size_banner.setCustomValidity("");
      }
      // let image = document.getElementById("image");
      // console.log("iamggeee",this.images,image)
      // if (this.images == undefined || this.images == null || this.images == ''){
      //   console.log("iamggeee",this.images)
      //   image.setCustomValidity("Image cannot be empty!");
      // }else {
      //   image.setCustomValidity("");
      // }

      let date_from = document.getElementById("date_from");


      // this.banner.from = this.model.date_from ? moment(this.model.date_from).format("DD-MM-yyyy"):null;
      // this.banner.to = this.model.date_to ? moment(this.model.date_to).format("DD-MM-yyyy"):null;

      console.log("tttt",this.isDate1BeforeDate2(this.banner.to,this.banner.from))
      console.log("datefrom",this.banner.from)
      console.log("dateto",this.banner.to)

      if (this.isDate1BeforeDate2(this.banner.to, this.banner.from) == true){
        date_from.setCustomValidity("Fromm cannot be larger than To");
      }else {
        date_from.setCustomValidity("");
      }
      // console.log("sasasasa",this.isDate1BeforeDate2(this.banner.from,this.banner.to))
      // if (this.isDate1BeforeDate2(this.banner.from,this.banner.to) == false )
      // {
      //   alert("The first day cannot be greater than the last day")
      //   return
      // }
      // let date_to = document.getElementById("date_to");
      // if (this.banner.to == undefined || this.banner.to == null || this.banner.to == ''){
      //   date_to.setCustomValidity("Date To cannot be empty!");
      // }else {
      //   date_to.setCustomValidity("");
      // }
      var images_va = document.getElementById("images_va");
      if (!(this.images && this.images.length)){
        images_va.setCustomValidity(this.$constants.MSG_TEXT.IMAGE_INVALID_MSG);
      }else {
        images_va.setCustomValidity("");
      }
      
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }

    },

  
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }

      console.log("wqwqqwqwq",this.banner.from, this.banner.to,this.banner.link,this.images)
      var arr_active = ['Large','Medium','Small','Intro']
      console.log("sasasas",this.banner.large)
      var arr_active_new = []
      for (var i = 0 ; i <arr_active.length ; i++ ){
        if (arr_active[i] == 'Large' ){
          if (this.banner.large == true){
            arr_active_new.push('Large')
          }
        }
        else if (arr_active[i] == 'Medium' ){
          if (this.banner.medium == true){
            arr_active_new.push('Medium')
          }
        }
        else if (arr_active[i] == 'Small' ){
          if (this.banner.small == true){
            arr_active_new.push('Small')
          }
        }
        else if (arr_active[i] == 'Intro' ){
          if (this.banner.intro == true){
            arr_active_new.push('Intro')
          }
        }

      }
      arr_active = arr_active_new
      // arr_active.push("Small")
      // var convert_from = moment.tz(this.banner.from, this.time_zone_local).format("yyyy-MM-DD 00:00:00");
      // convert_from =  moment.tz(convert_from,'utc')
      // console.log("accccc",arr_active_new,this.banner.large)

      // this.banner.from = this.banner.from ? moment(this.banner.from, 'DD/MM/yyyy'):null;
      // this.banner.from = this.banner.from ? this.banner.from.format('MM/DD/yyyy'):null;
      //
      // this.banner.to = this.banner.to ? moment(this.banner.to, 'DD/MM/yyyy'):null;
      // this.banner.to = this.banner.to ? this.banner.to.format('MM/DD/yyyy'):null;

      var params = {
        date_from: this.banner.from,
        date_to: this.banner.to,
        link: this.banner.link,
        active: this.banner.active,
        images: this.images,
        active_distance: arr_active,
        ordinal : this.banner.ordinal,
        // imagesDeletes: this.imgDelete,
        // content :this.content,
        // content_en :this.content_en,
      }
        console.log("params",params)
      this.$emit('save', params);
      
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if(files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF']
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split('.').pop())) {
            alert("Please upload a maximum of " + this.maxFiles + " photos");
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("The maximum number of images is " + this.maxFiles + " images");
        } else {
          var arrTemp = [], arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }
          
          if (arrFiles.length > 0) {
            alert("Your image is over 500MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === '') {
              this.imagesDeletes.push(this.images[0])
            }
            this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
            // console.log(this.images)
            // await this.validateData()
          }
        }
      }
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === '') {
        this.imgDelete.push(img)
      }
    }
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">

  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .p-invalid {
    color: red;
    margin: 1px 0px 0px 0px;
  }
  .text-active{
    margin: 0px 0px 0px 8px;
  }
  .color{
    color: red!important;
  }
  .text-active{
    padding: 0px!important;
    margin-bottom: 0px!important;
  }
  .div-active{
    display: flex!important;
    margin-bottom: 12px!important;
  }
  .div-active-item{
    max-width: 120px!important;
    width: 50px!important;
    display: flex!important;
    align-items: flex-start!important;
  }
  .div-p{
    text-align: left!important;
    justify-content: left!important;
  }
  .text-distance{
    display: block!important;
  }
  .div-block{
    display: block!important;
    padding-left: 12px!important;
  }
  .div-big{
    padding: 0px!important;
  }
  .label-thumbnail{
    display: unset!important;
    //margin: 12px!important;
  }
  .label-bot-item{
    display: block!important;
    text-align: left!important;
  }
  .div-calenda{
    display: flex!important;
  }
  .bold{
    font-weight: bold!important;
  }
  #div-thumbnail{
    width: 650px!important;
  }
  .link-width{
    width: 650px!important;
    margin-left: 7px!important;
  }
  .color-text{
    color: #808080;
  }
  .div-canlenda-item{
    margin-right: 12px!important;
  }
  .col-12{
    padding-left: 5px!important;
  }
  .p-card-field{
    padding: 7px!important;
  }
.p-col{
  padding: 0px!important;
}
.p-col-fixed{
  padding: 0px!important;
}
/* .p-calendar-w-btn{
  width: 319px!important;
} */
.width-thum{
  margin-top: 12px!important;
}
  //.pi-check{
  //  background-color:#E73725 !important;
  //  border: 1px solid #E73725;
  //}

  .save{
    background-color: #E73725!important;
    border: 1px solid #E73725!important;
  }
  .cancel{
    border: 1px solid #E73725!important;
    color: #E73725!important;
  }
  .one-active{
    margin-left: 5px!important;
  }
  .item-img{
    width: 300px!important;
    height: 200px!important;
  }
  
  </style>
